import React from 'react';

import { UPLOAD_VIDEO_CONFIG } from '@assetManagement/data/uploadVideoConfig';
import FileDragDrop from 'components/FileDragDrop';
import FileSelect from 'components/FileSelect';
import styles from './UploadVideoInput.module.scss';

export default function UploadVideoInput({ onFileSelected }) {
  return (
    <FileDragDrop onDrop={onFileSelected}>
      <div className={styles.fileDropContainer}>
        <span className={styles.fileDropHeader}>Drag and drop files</span> or
        <FileSelect
          accept={UPLOAD_VIDEO_CONFIG.allowedVideoType}
          onChange={onFileSelected}
        >
          Click here to select file
        </FileSelect>
      </div>
    </FileDragDrop>
  );
}
